export default function Detail() {
  return (
    <>
      <h2>상세정보</h2>
      <p>
        ab nobis ullam esse laboriosam mollitia. Lorem ipsum dolor sit amet consectetur adipisicing
        elit. Ab eum odio quod fuga itaque ducimus architecto delectus modi porro adipisci. Corporis
        rem blanditiis laudantium ab nobis ullam esse laboriosam mollitia.
      </p>
    </>
  );
}
